/**
 * Isolated timer state for in-app-comms retry logic.
 *
 * Kept in its own module so that login-actions.ts can call cancelPendingRetries()
 * on logout without importing in-app-comms-actions.ts — which would create a
 * circular dependency through data/api.ts.
 */

export const pendingRetryTimers = new Set<ReturnType<typeof setTimeout>>()

export const cancelPendingRetries = (): void => {
    pendingRetryTimers.forEach(id => clearTimeout(id))
    pendingRetryTimers.clear()
}
